
import { throwError } from 'rxjs';

export abstract class BaseService {

    protected handleError(error: any) {
        const applicationError = error.headers.get('Application-Error');
        // either applicationError in header or model error in body
        if (applicationError) {
            return throwError(applicationError);
        }

        let modelStateErrors: string[] = [];

        // map net::ERR_CONNECTION_REFUSED to ['Error.null']
        if (error.statusText === 'Unknown Error') {
            return throwError(['ERROR.null']);
        }

        const serverError = error.error;

        if (!serverError.type) {
            for (const key in serverError) {
                if (serverError[key]) {
                // eslint-disable-next-line @typescript-eslint/prefer-for-of
                for (let i = 0; i < serverError[key].length; i++) {
                    if (modelStateErrors.indexOf(serverError[key][i]) === -1) {
                        modelStateErrors.push(serverError[key][i]);
                    }
                }
                }
            }
        }

        modelStateErrors = modelStateErrors = '' ? null : modelStateErrors;
        return throwError(modelStateErrors || 'Server error');
    }
}
